document.addEventListener('DOMContentLoaded', function() {
  const workCards = document.querySelectorAll('.work-card');
  
  // Check if it's a touch device
  const isTouchDevice = ('ontouchstart' in window) || 
                        (navigator.maxTouchPoints > 0) || 
                        (window.matchMedia && window.matchMedia('(hover: none)').matches);
  
  // On mobile, we don't need any interaction since content is always visible
  if (isTouchDevice) {
    // Just ensure no active class remains (cleanup)
    workCards.forEach(card => {
      card.classList.remove('active');
    });
    
    // Remove any click/tap listeners since they're not needed
    // Content is always visible on mobile
    console.log('Mobile detected - content always visible');
    
  } else {
    // Desktop: Remove any active classes (cleanup)
    workCards.forEach(card => {
      card.classList.remove('active');
    });
    
    console.log('Desktop detected - hover effects active');
  }
});